var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#00B081"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2923 18.2852C36.6569 17.8477 36.5978 17.1974 36.1602 16.8328C35.7227 16.4682 35.0724 16.5273 34.7078 16.9648L27.2956 25.8595C25.8067 27.6461 24.7593 28.8991 23.8509 29.7195C22.9636 30.5207 22.3513 30.7753 21.75 30.7753C21.1488 30.7753 20.5365 30.5207 19.6492 29.7195C18.7407 28.8991 17.6933 27.6461 16.2044 25.8594L14.2923 23.5648C13.9276 23.1273 13.2774 23.0682 12.8398 23.4328C12.4023 23.7974 12.3432 24.4477 12.7078 24.8852L14.673 27.2435C16.0965 28.9518 17.2365 30.3198 18.2669 31.2502C19.3312 32.2113 20.4192 32.8378 21.75 32.8378C23.0808 32.8378 24.1688 32.2113 25.2332 31.2502C26.2635 30.3198 27.4035 28.9518 28.827 27.2436L36.2923 18.2852Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.6864451d55aab470ff9693cfd22b885f.svg";
export { ForwardRef as ReactComponent };